import React from 'react';
import MovementsTable from './table/MovementsTable';
import { MovementsUIProvider } from './context/MovementsUIContext';
import MovementsHeader from './MovementsHeader';
import { Box, Card } from '@mui/material';
import ProductsDropMenu from '../../products/ProductsDropMenu';

export default function Movements () {
    return (
        <MovementsUIProvider>
            <Box display='flex' flexDirection='column' justifyContent='center' width='100%' marginRight={'2rem'}>
                <Box style={{ borderRadius: '4px', marginTop: '1rem', width: '100%', margin: '1rem 1rem 0 1rem' }}>
                    <Card sx={{ boxShadow: 'none' }}>
                        <MovementsHeader />
                    </Card>
                </Box>
                <div className='menuFlex'>
                    <div className='menuFlexLeft'>
                        <ProductsDropMenu />
                    </div>
                    <div className='menuFlexRight'>
                        <MovementsTable />
                    </div>
                </div>
            </Box>
        </MovementsUIProvider>
    );
}
